/// <reference path="../oidc/oidc-client.d.ts"/>
/// <reference path="../../../../../node_modules/@docuware-internal/shared-web-resources/SharedResources/Scripts/TypeScript/CompileReferences.ts" />

namespace Platform {
    export class LogInVM extends DWTS.Disposable {
        public user: KnockoutObservable<Oidc.User> = ko.observable(null);
        public logIn: DW.Command;
        public logOff: DW.Command;

        constructor(private userManager: Oidc.UserManager) {
            super();

            this.userManager.getUser().then((user: Oidc.User) => {
                this.user(user);
            });

            this.initCommands();
        }

        private initCommands(): void {
            this.logIn = this.addDisposable(new DW.Command({
                execute: () => {
                    this.userManager.signinRedirect({
                        state: {
                            redirectLocation: window.location.href
                        }
                    });
                }
            }));

            this.logOff = this.addDisposable(new DW.Command({
                execute: () => {
                    this.userManager.clearStaleState();
                    this.userManager.signoutRedirect({
                        extraQueryParams: {
                            auto: false
                        }
                    });
                }
            }));
        }
    }
}